<template>
  <el-radio-group v-model="selectValue" @change="onChange">
    <el-radio
      v-for="item in selectOptions"
      :key="item.value"
      :label="String(item.value)"
      :value="String(item.value)"
      >{{ item.label }}</el-radio
    >
  </el-radio-group>
</template>

<script>
import {
  createVNode,
  defineComponent,
  onMounted,
  toRefs,
  getCurrentInstance,
  reactive,
  ref,
  watch,
} from "vue";
import { replaceObjectKeys } from "@pansy/utils";
import selectMixin from "./selectMixin";

export default defineComponent({
  name: "sSelect",
  mixins: [selectMixin],
  props: {},
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const state = reactive({
      selectOptions: [],
      selectValue: null,
    });

    // 获取下拉选项
    const getData = (obj) => {
      if (props.url) {
        proxy.$api[props.url]({ ...props.params, ...obj }).then((res) => {
          const data = res.data ? res.data : res.rows ? res.rows : res;
          state.selectOptions = props.field
            ? replaceObjectKeys(data, props.field)
            : data;
        });
      } else if (props.options && props.options.length > 0) {
        state.selectOptions = props.field
          ? replaceObjectKeys(props.options, props.field)
          : props.options;
      }
    };

    onMounted(() => {
      state.selectValue = props.modelValue;

      getData();
    });

    watch(
      () => props.modelValue,
      (n) => {
        state.selectValue = n;
      }
    );

    watch(
      () => props.params,
      (n) => {
        getData();
      }
    );
    watch(
      () => props.options,
      (n) => {
        if (!props.url) {
          getData();
        }
      }
    );

    const onChange = (value, option) => {
      emit("update:modelValue", state.selectValue);
      emit("change-check", value, option);
    };

    return {
      ...toRefs(state),
      onChange,
      getData,
    };
  },
});
</script>
<style lang="less">
.g-select {
  &.ant-select {
    width: 218px;
  }
}
</style>
